import React, { useEffect } from 'react';
import {
TextField,
InputAdornment,
Paper,
Checkbox,
Box,
Divider,
Button
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { makeStyles } from '@mui/styles';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import UserList from '../userList/userList';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import Helper from '../../utility/helper';
import { useState, Downgraded } from '@hookstate/core';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import UserCheckList from '../userList/userCheckList';
import ParticipantUserCheckList from '../userList/participantUserCheckList';
import ParticipantUserAddedCheckList from '../userList/participantUserAddedCheckList';


const useStyles = makeStyles({
    dialogContentRoot: {
        // maxHeight: 400,
        // overflowY: 'hidden',
        '&::-webkit-scrollbar': {
            width: '5px',
            height: '5px',
            backgroundColor: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#c1c1c1',
        },
    },
});


const ConnectionListDialog = (props) => {
    const classes = useStyles();

    const selectedUsers = useState([]);
    const eventInfo = useState(null);
    const userInfo = useState(null);
    const finalEventParticipants = useState([]);
    const eventData = useState(null);
    const [search, setSearch] = React.useState('');
    const primaryUserId = useState(null);
    const [users, setUsers] = React.useState([])
    const rightSelected = useState([]);   
    const selected = useState([]);
    const [allCheck, setAllCheck] = React.useState(false);
    const [getTitle, setGetTitle] = React.useState('');
    const [inviteParticipants, setInviteParticipants] = React.useState([]);
    const [leftParticipants, setLeftParticipants] = React.useState([]);
    const [rightParticipants, setRightParticipants] = React.useState([]);
    const [resetCheckBox, setResetCheckBox] = React.useState(false);
    const rightSelectedUsers = useState([]);
    const [addsearch, setAddSearch] = React.useState('');
    const [disbaledBtn, setDisbaledBtn] = React.useState(false);
    const [rightDefaultParticipants, setRightDefaultParticipants] = React.useState([]);
    const [sortOrder, setSortOrder] = React.useState('user');
    useEffect(() => {
        const userEventInfo = Helper.getStorage('eventInfo');
        const guserInfo = Helper.getStorage('userInfo');
        eventInfo.set(userEventInfo);
        userInfo.set(guserInfo);
        setUsers(props.eventParticipants)        
    }, []);
    const handleOnSearchChange = (val) => {
        let value = val.replace(/^\s+/g, '');
        setSearch(value);
        let newUsers = [...props.eventParticipants];
        if (value.length > 0) {
            newUsers = props.eventParticipants.filter(x => x.name.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
                (x.roleName && x.roleName !== null && x.roleName.toLowerCase().indexOf(value.toLowerCase()) > -1) ||
                (x.userTags && x.userTags !== null && x.userTags.toLowerCase().indexOf(value.toLowerCase()) > -1))
            setUsers(newUsers)
        } else {
            setUsers([...props.eventParticipants])
        }


    }  
    const mergerArrayData = (data1, data2) => {
        const mergedArray = data1.map(obj1 => {
            const match = data2.find(obj2 => obj2.userID === obj1.userID);
            return {
                ...obj1,
                ...(match ? { firstName: match.firstName, lastName: match.lastName, createdDate: match.createdDate } : {}) // Add firstName & lastName if match found
            };
        });
        return mergedArray;
    }
    useEffect(() => {
        const { eventParticipants, users } = props;
        // console.log("eventParticipants, users",eventParticipants, users);
        if (eventParticipants && eventParticipants.length > 0) {
            const finalParticipants = eventParticipants.map((item) => item);
            finalEventParticipants.set(finalParticipants);

            const leftArrow = eventParticipants.filter((i) => i.userID !== props.eventUserInfo.userID);
            if (props.eventUserInfo.userConnection && props.addConnectionFor == 'connections') {
                let checkedUsers = props.eventUserInfo.userConnection.map(item => item.userID)
                let data = leftArrow.filter(item => !checkedUsers.includes(item.userID)); 
                const mergedArray = mergerArrayData(data, users)
                // console.log("mergedArray",mergedArray);
                
                setLeftParticipants(mergedArray.sort((a, b) => a.lastName.localeCompare(b.lastName)))
            } else {
                let checkedUsers = props.eventUserInfo.linkedWith.map(item => item.userID)
                let data = leftArrow.filter(item => !checkedUsers.includes(item.userID)); 
                const mergedArray = mergerArrayData(data, users)                
                setLeftParticipants(mergedArray.sort((a, b) => a.lastName.localeCompare(b.lastName)))
            }
        }

        if (users && eventParticipants.length === 0) {
            setInviteParticipants(() => users);
            setLeftParticipants(() => users);
        }
    }, [props.eventParticipants, props.users]); 


    useEffect(() => {
        if (props.eventParticipants && props.eventParticipants.length > 0) {
            let eventParticipants = props.eventParticipants;
            let finalParticipants = eventParticipants.map(item => item.userID);
            finalEventParticipants.set(finalParticipants);

        }
        if (props.eventUserInfo) {
            primaryUserId.set(props.eventUserInfo)
            // console.log('userId',props.eventUserInfo)
            // console.log('addconnectionFor',props.addConnectionFor)

            if (props.eventUserInfo.userConnection && props.addConnectionFor == 'connections') {
                let checkedUsers = props.eventUserInfo.userConnection.map(item => item.userID)  
                let data = props.eventParticipants && props.eventParticipants.filter(item => checkedUsers.includes(item.userID));
                setRightDefaultParticipants(data) 
            } else {
                let checkedUsers = props.eventUserInfo.linkedWith.map(item => item.userID)
                let data = props.eventParticipants && props.eventParticipants.filter(item => checkedUsers.includes(item.userID));
                setRightDefaultParticipants(data) 
                // let data = leftParticipants.filter(item => !checkedUsers.attach(Downgraded).get().includes(item.userID));
                // setLeftParticipants(data)
                // console.log('selectedUsers',checkedUsers)
                // selectedUsers.set(checkedUsers);
            }
        }

    }, [props]);
    useEffect(() => {
        const eventInfo = Helper.getStorage('eventInfo');
        if ((eventData.get() == null || (
            eventData.get() && eventData.eventID.value != eventInfo.eventID
        ))) {
            eventData.set(eventInfo);
        }
        let newTitle = "";
        if(props.addConnectionFor == 'connections'){
            newTitle = `${props.title} On Behalf Of ${props.eventUserInfo && props.eventUserInfo.name.replace(',', '')}` ;
        }else{
            newTitle = `${props.title} Linked with ${props.eventUserInfo && props.eventUserInfo.name.replace(',', '')}`;
        }
        setGetTitle(newTitle)
    }, [props]);


    const checkSelectedUsers = (value) => {
        // console.log('checkSelectedUsers : ', value);
        selectedUsers.set(value);
        onAddParticipant()
    }
    const handleAllCheck = () => {
        let data = [];
        users.map((item) => {
            data.push(item.userID);
        });
        if (allCheck === false) {
            setAllCheck(true)
            selectedUsers.set(data)
        } else {
            setAllCheck(false)
            selectedUsers.set([])
        }
    }
    const rightCheckSelectedUsers = (value) => {       
        rightSelectedUsers.set(value);
    }; 

    const onAddParticipant = () => {
        // if (selectedUsers.attach(Downgraded).get().length == 0) {
        //     props.setSnackBarProps({
        //         ...props.snackBarProps,
        //         openSnack: true,
        //         variant: 'error',
        //         message: 'Please select participants',
        //     });
        //     return false
        // } else {
            const deletedData = leftParticipants.filter((val) => selectedUsers.attach(Downgraded).get().includes(val.userID))
            let data = leftParticipants.filter(item => !selectedUsers.attach(Downgraded).get().includes(item.userID));
            setLeftParticipants(data)
            if (search && search.length > 0) {
                let searchData = inviteParticipants.filter(item => !selectedUsers.attach(Downgraded).get().includes(item.userID));
                setInviteParticipants(searchData)
            }
            setResetCheckBox(true)
            setSearch('')
            const newRightPart = deletedData.concat(rightDefaultParticipants)
            setRightDefaultParticipants(newRightPart)
            selectedUsers.set([])
            rightSelected.set([])
        // }

    }
    const onRemoveParticipant = () => {
        // console.log(rightSelectedUsers.attach(Downgraded).get());
        const deletedData = rightDefaultParticipants.filter((val) => rightSelectedUsers.attach(Downgraded).get().includes(val.userID))
        let data = rightDefaultParticipants.filter(item => !rightSelectedUsers.attach(Downgraded).get().includes(item.userID));
        // console.log("deletedData",deletedData, "data",data);
        setRightDefaultParticipants(data)
        if (addsearch && addsearch.length > 0) {
            let searchAddData = rightParticipants.filter(item => !rightSelectedUsers.attach(Downgraded).get().includes(item.userID));
            // console.log("searchAddData",searchAddData);
            setRightParticipants(searchAddData)
        }
        let newR = leftParticipants;
        const newRightPart = deletedData.concat(newR)
        setResetCheckBox(true)
        // console.log("newRightPart",newRightPart,deletedData, "newR",newR);
        rightSelectedUsers.set([])
        setLeftParticipants(newRightPart)
        selectedUsers.set([])
        selected.set([]);
        setAddSearch('')
    }
    const setInviteParticipantsss = (items) => {
        // console.log("items",items);
        setRightParticipants(items)
    }
    // const renderDialogContent = () => (
    //     <>
    //         <Box sx={{
    //             display: 'flex',
    //             flexDirection: 'row',
    //             justifyContent: 'left',
    //             alignItems: 'left',
    //         }}>
    //             <Checkbox
    //                 edge="start"
    //                 checked={allCheck}
    //                 onChange={handleAllCheck}
    //                 disableRipple
    //                 sx={{ ml: "4px" }}
    //             />
    //             <TextField
    //                 size="small"
    //                 fullWidth={true}
    //                 placeholder="Search Individuals or Groups"
    //                 InputProps={{
    //                     startAdornment: (
    //                         <InputAdornment position="start">
    //                             <SearchIcon />
    //                         </InputAdornment>
    //                     ),
    //                 }}
    //                 value={search}
    //                 onChange={(event) => handleOnSearchChange(event.target.value)}
    //             />
    //         </Box>

    //         <Paper>
    //             <UserCheckList
    //                 search={search}
    //                 data={users}
    //                 selectedUsers={selectedUsers.attach(Downgraded).get()}
    //                 checkUsers={checkSelectedUsers}
    //                 showRole={true}
    //                 skipEventParticipants={[props.eventUserInfo.userID]} />
    //         </Paper>

    //     </>
    // );
    const sortParticipants = (sort) => {
        setSortOrder(sort)
        if(sort === 'user'){
            const newParti = [...leftParticipants].filter((i) => rightDefaultParticipants && rightDefaultParticipants.length > 0 ? rightDefaultParticipants.every((j) => i.userID !== j.userID) : [...leftParticipants])
            const newLeftParti =  mergerArrayData(newParti, props.users)

            const sorted = newLeftParti.sort((a, b) => {
                return  a.lastName.localeCompare(b.lastName) 
            }); 
            setLeftParticipants(sorted);
        }else{
            const newParti = props.eventParticipants.filter((i) => rightDefaultParticipants && rightDefaultParticipants.length > 0 ? rightDefaultParticipants.every((j) => i.userID !== j.userID) : [])
            const newLeftParti =  mergerArrayData(newParti, props.users)
            const sorted = newLeftParti.sort((a, b) => {
                return  new Date(b.createdDate) - new Date(a.createdDate)  
            }); 
            setLeftParticipants(() => sorted);             
        } 
    }
    const renderDialogContent = () => (
        <>
            <Box sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                marginTop: 2,
            }}>
                <Paper sx={{ width: '48%' }}>
                    <ParticipantUserCheckList
                        data={search && search.length > 0 ? inviteParticipants : leftParticipants}
                        checkUsers={checkSelectedUsers}
                        selectedUsers={selectedUsers.attach(Downgraded).get()}
                        setInviteParticipants={setInviteParticipants}
                        setSearch={setSearch}
                        search={search}
                        onAddParticipant={onAddParticipant}
                        resetCheckBox={resetCheckBox}
                        setResetCheckBox={setResetCheckBox}
                        setLeftParticipants={setLeftParticipants}
                        sortParticipants={sortParticipants}
                        sortOrder={sortOrder}
                    />
                    <Divider />
                    <Button disabled={selectedUsers.attach(Downgraded).get().length == 0 ? true : false} sx={{ margin: 1 }} onClick={onAddParticipant} size="small" variant="outlined">Add</Button>
                </Paper>

                <Paper sx={{ width: '48%' }}>
                    <ParticipantUserAddedCheckList
                        data={addsearch && addsearch.length > 0 ? rightParticipants : rightDefaultParticipants}
                        checkUsers={rightCheckSelectedUsers}
                        selectedUsers={rightSelected.attach(Downgraded).get()}
                        setInviteParticipants={setInviteParticipantsss}
                        setAddSearch={setAddSearch}
                        addsearch={addsearch}
                        resetCheckBox={resetCheckBox}
                        setResetCheckBox={setResetCheckBox}
                    />
                    <Divider />
                    <Button disabled={rightSelectedUsers.attach(Downgraded).get().length == 0 ? true : false} sx={{ margin: 1 }} onClick={onRemoveParticipant} size="small" variant="outlined">Remove</Button>
                    <Button disabled={rightSelectedUsers.attach(Downgraded).get().length == 0 ? true : false} sx={{ margin: 1 }} onClick={handleUpdateSubmit} size="small" variant="outlined">Remove & Update</Button>
                </Paper>
            </Box>
        </>
    );
    const renderDialogActions = () => (
        <ButtonContainer
            handleClick={handleClick}
            disabled={disbaledBtn}
            showLoading={true}
            loading={disbaledBtn}
            handleCancel={props.handleClose}
            buttonText={'Create'}
        />
    );
    const handleUpdateSubmit = () => {           
        let connectionIDvar; 
        if(props.addConnectionFor == 'connections'){
            let cIds = props.eventUserInfo.userConnection.filter(item => rightSelectedUsers.attach(Downgraded).get().includes(item.userID));
            connectionIDvar = cIds && cIds.map(item => item.connectionID)
        }else{
            let LIds = props.eventUserInfo.linkedWith.filter(item => rightSelectedUsers.attach(Downgraded).get().includes(item.userID));
            connectionIDvar = LIds && LIds.map(item => item.userID)            
        }
        let requestObj = {
            connectionIDs: connectionIDvar.join(','),
            modifiedBy: userInfo.attach(Downgraded).get().userID,
            eventID: eventInfo.attach(Downgraded).get().eventID,
            userID: props.eventUserInfo.userID,
            isPrimary: props.addConnectionFor == 'connections' ? false : true
        }       
        setDisbaledBtn(true) 
        if(connectionIDvar.length === 0){
            props.handleClose();
            props.getParticipants();
            props.getAllParticipants();
        }else{
            ApiHelper.post(APIURLConstants.DELETE_MULTIPLE_CONNECTIONS, requestObj)
            .then((res) => {
                if (res.data) {
                    setDisbaledBtn(false)
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'connections deleted successfully',
                    });
                    props.handleClose();
                    props.getParticipants();
                    props.getAllParticipants();
                }})
                .catch((error) => {
                    console.log('error : ', error);
                    setDisbaledBtn(false)
                    let message = '';
                    if (error.response && error.response.status === 401) {
                        message = 'Access denied';
                    } else {
                        message = 'Error while adding participant';
                    }
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });                    
                });  
        }
        
    }
    const handleClick = () => {
        if (rightDefaultParticipants.length == 0) {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select participants',
            });
        }
        else {
            setDisbaledBtn(true) 
            let users = rightDefaultParticipants.map(item => item.userID) 
            let count = 1;
            let requestObj = {
                eventID: eventInfo.attach(Downgraded).get().eventID,
                createdBy: userInfo.attach(Downgraded).get().userID,
                IsLinkedWith: props.addConnectionFor == 'connections' ? false : true,
                Connections: users.map((item) => {
                    return {
                        primaryUserID: props.addConnectionFor == 'connections' ? props.eventUserInfo.userID : item,
                        connectedTo: props.addConnectionFor == 'connections' ? item : props.eventUserInfo.userID,
                        Priority: count++,
                        IsHide: false,
                        IsLinkedWith: props.addConnectionFor == 'connections' ? false : true,
                    };
                })
            };
            ApiHelper.post(APIURLConstants.POST_ADD_CONNECTION, requestObj)
                .then((res) => {
                    if (res.data > 0) {
                        setDisbaledBtn(false)
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'Participants added successfully',
                        });
                        props.handleClose();
                        props.getParticipants();
                        props.getAllParticipants();
                    }
                })
                .catch((error) => {
                    console.log('error : ', error);
                    setDisbaledBtn(false)
                    let message = '';
                    if (error.response && error.response.status === 401) {
                        message = 'Access denied';
                    } else {
                        message = 'Error while adding participant';
                    }
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });                    
                });            
        }

    };

    return (
        <CustomDialog
            title={getTitle}
            handleClose={props.handleClose}
            open={props.open}
            fullWidth={true}
            maxWidth={'sm'}
            // title={'Export Itinerary'}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
            dialogContentClasses={{ root: classes.dialogContentRoot }}
        />
    );
};
export default ConnectionListDialog;
